// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2K-TF","alert":"SettungsInbox_alert__1IRm4"};